import IconStar from "../icons/IconStar";

type ShowRateOnItemProps = {
  value: number
}

export default function ShowRateOnItem(props: ShowRateOnItemProps) {

  const { value } = props;
  if (value && value > 0)
    return (<div className="flex flex-row gap-2 items-center text-light-300 align-middle text-base">
      {Math.round(value * 10 / 20) / 10}
      <IconStar className="text-yellow-400" width={20} height={20} />
    </div>)
  return null;
}